import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const RestoreIcon = (props: IconProps) => (
  <Icon width="21px" height="20px" viewBox="0 0 21 20" {...props}>
    <path d="M16.3968 3.85683c-3.3231-3.323063-8.71219-3.323064-12.03526 0L2.35567 1.85096v5.34899h5.349L5.69879 5.19408c2.58758-2.58758 6.77321-2.58758 9.36071 0 2.5876 2.58758 2.5876 6.77312 0 9.36072-2.5875 2.5876-6.77313 2.5876-9.36071 0-1.00962-1.0096-1.61807-2.2733-1.8454-3.5838l-1.91227.0134c.24071 1.7919 1.04306 3.5303 2.42042 4.9077 3.32307 3.323 8.71216 3.323 12.03526 0 3.323-3.3231 3.323-8.71221 0-12.03527Z" />
    <path d="M11.3943 6.66666H9.51929v2.8125h-2.8125v1.87504h2.8125v2.8125h1.87501v-2.8125h2.8125V9.47916h-2.8125v-2.8125Z" />
  </Icon>
);

export default memo(RestoreIcon);
